import { ExportCurve, SearchNormal } from "iconsax-reactjs";
import { ActivitySort } from "../types";
import { Button, Input, Select } from "../../../shared/ui";

type ActivityFiltersBarProps = {
  query: string;
  onQueryChange: (value: string) => void;
  sort: ActivitySort;
  onSortChange: (value: ActivitySort) => void;
  sortOptions: Array<{ value: string; label: string }>;
  onExport: () => void;
  isExporting?: boolean;
};

const ActivityFiltersBar = ({
  query,
  onQueryChange,
  sort,
  onSortChange,
  sortOptions,
  onExport,
  isExporting = false,
}: ActivityFiltersBarProps) => {
  return (
    <div className="my-4 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
      <Button
        onClick={onExport}
        disabled={isExporting}
        className="order-1 self-start px-7 text-[14px] font-[550] lg:order-2 lg:px-5"
      >
        <ExportCurve size={18} />
        {isExporting ? "Exporting..." : "Export"}
      </Button>

      <div className="order-2 flex flex-1 flex-col gap-4 lg:order-1 lg:flex-row lg:items-center lg:gap-3">
        <Input
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="Search activity"
          startIcon={<SearchNormal size={20} className="text-[#6F739B]" />}
          className="w-full lg:w-[360px]"
        />

        <div className="hidden h-10 w-px bg-[#EEF1FB] lg:block" />

        <Select
          value={sort}
          onChange={(value) => onSortChange(value as ActivitySort)}
          title="Sort by"
          placeholder="Recent"
          triggerPrefix="Sort"
          className="w-fit lg:w-auto"
          options={sortOptions}
        />
      </div>
    </div>
  );
};

export default ActivityFiltersBar;
